// extracted by mini-css-extract-plugin
module.exports = {"dropzone-container":"upload-dropzone_dropzone-container__1HHNA"};